
module.exports = (function() {

    return {

        getEnclosingRegion: (entitiesResult) => {
            let enclosingRegion = null;
            if (entitiesResult) {
                if ('location' in entitiesResult) {
                    entitiesResult = entitiesResult['location'];
                }
                if (entitiesResult.dsgFeatureCode && entitiesResult.dsgFeatureCode==='PCLI') {
                    return null;
                }
                if (entitiesResult.admin2Label) {
                    enclosingRegion = entitiesResult.admin2Label;
                }
                if (entitiesResult.admin1Label) {
                    if (enclosingRegion && enclosingRegion.length > 0) {
                        enclosingRegion += '-';
                    } else {
                        enclosingRegion = '';
                    }
                    enclosingRegion += entitiesResult.admin1Label;
                }
                if (entitiesResult.countryLabel) {
                    if (enclosingRegion && enclosingRegion.length > 0) {
                        enclosingRegion += '-';
                    } else {
                        enclosingRegion = ''; 
                    }
                    enclosingRegion += entitiesResult.countryLabel;
                }                    
            }
            return enclosingRegion;
        },
        
        getCoordinates: (entitiesResult) => {
            let coords = null;
            if (entitiesResult) {
                if ('location' in entitiesResult) {
                    entitiesResult = entitiesResult['location'];
                }
                if (('latitude' in entitiesResult) && ('longitude' in entitiesResult)) {
                    coords = entitiesResult.latitude + ',' + entitiesResult.longitude;
                }
            }
            return coords;
        },

        getPopulation: (entitiesResult) => {
            let pop = null;
            if (entitiesResult && ('location' in entitiesResult)) {
                entitiesResult = entitiesResult['location'];
            }
            if (entitiesResult && entitiesResult.population) {
                pop = (entitiesResult.population + '').replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
            return pop;            
        },

        getBoundingBox: (entitiesResult) => {
            let bounds = null;
            if (entitiesResult && ('location' in entitiesResult)) {
                entitiesResult = entitiesResult['location'];
            }
            if (entitiesResult && entitiesResult.boundingBox) {
                bounds = entitiesResult.boundingBox;
            }
            return bounds;
        },

        isPointInBoundingBox: (lat, lng, bb) => {
            if (lat && lng && bb) {
                if (lat <= bb.maxLatitude && lat >= bb.minLatitude && lng <= bb.maxLongitude && lng >= bb.minLongitude) {
                    return true;
                }
            }
            return false;            
        }
    };
})();
